module.exports = __webpack_public_path__ + "img/Johnston.651922e7.jpg";